import "./banner.css";

export default function Banners({ banners, tipo }) {
  const bannerFiltrado = banners.find(b => b.tipo === tipo);
  if (!bannerFiltrado) return null;

  return (
    <div className={`container-banners ${tipo}`}>
      <picture>

        {/* 🔥 Só troca imagem no mobile se for RETANGULAR */}
        {tipo === "retangulo" && bannerFiltrado.banner_mobile && (
          <source
            media="(max-width: 768px)"
            srcSet={bannerFiltrado.banner_mobile}
          />
        )}

        {/* imagem padrão */}
        <img
          src={bannerFiltrado.banner}
          alt={`Banner ${tipo}`}
          loading="lazy"
        />
      </picture>
    </div>
  );
}